import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import form1 from '../../assets/forms/form1.png'
import form2 from '../../assets/forms/form2.png'
import form3 from '../../assets/forms/form3.jpg'
import renovaciones from '../../assets/renovaciones.png'
import Swal from 'sweetalert2';



const FormsOptions = () => {

  const token = localStorage.getItem('token');
  


  return (
    <div className='w-screen flex flex-col sm:flex-row items-center justify-center p-12 sm:pt-28 gap-12 sm:gap-20'>


<div className='border border-slate-100 w-80 h-96 rounded-xl shadow-xl p-4 flex flex-col items-center justify-center bg-white'>
        <img src={form3} alt="img not found" className='w-52 h-52' />
            <div className='flex flex-col items-center justify-center gap-3 p-4'>
              <h1 className='font-bold'>Mis Formularios</h1>
              <p className='text-xs'>Acá podes ver todos los Formularios que completaste</p>
                <button className='w-full p-2 px-4 rounded-xl bg-background_home text-white '
                onClick={() => {
                  if (token) {
                    window.location.href='/misFormularios';
                  } else {
                    Swal.fire({
                      title: 'No esta Logeado',
                      text: 'Debe iniciar sesion para poder ver sus formularios.',
                      icon: 'warning',
                      confirmButtonColor: '#3085d6',
                      confirmButtonText: 'Aceptar'
                    });
                  }
                }}
                >Mis formularios</button>
            </div>
        </div>


        <div className='border border-slate-100 w-80 h-96 rounded-xl shadow-xl p-4 bg-white'>
        <img src={form2} alt="img not found" className=''/>
            <div className='flex flex-col items-center justify-center gap-3 p-4'>
              <h1 className='font-bold'>Declaración Jurada</h1>
              <p className='text-xs'>Solicitud de Inscripción al Registro Nacional de
               Pacientes en Tratamiento con Cannabis (REPROCANN)</p>
               <button className='w-full p-2 px-4 rounded-xl bg-background_home text-white '
                onClick={() => {
                  if (token) {
                    window.location.href='/declaracionjurada';
                  } else {
                    Swal.fire({
                      title: 'No esta Logeado',
                      text: 'Debe iniciar sesion para poder ver sus formularios.',
                      icon: 'warning',
                      confirmButtonColor: '#3085d6',
                      confirmButtonText: 'Aceptar'
                    });
                  }
                }}
                >Completar</button>
            </div>
        </div>  
        <div className='border border-slate-100 w-80 h-96 rounded-xl shadow-xl p-4 bg-white'>
        <img src={form1} alt="img not found" className=''/>
            <div className='flex flex-col items-center justify-center gap-3 p-4'>
              <h1 className='font-bold'>Consentimiento</h1>
              <p className='text-xs'>Solicitud de Inscripción al Registro Nacional de
               Pacientes en Tratamiento con Cannabis (REPROCANN)</p>
               <button className='w-full p-2 px-4 rounded-xl bg-background_home text-white '
                onClick={() => {
                  if (token) {
                    window.location.href='/anexousuario';
                  } else {
                    Swal.fire({
                      title: 'No esta Logeado',
                      text: 'Debe iniciar sesion para poder ver sus formularios.',
                      icon: 'warning',
                      confirmButtonColor: '#3085d6',
                      confirmButtonText: 'Aceptar'
                    });
                  }
                }}
                >Completar</button>
            </div>
        </div>  

        <div className='border border-slate-100 w-80 h-96 rounded-xl shadow-xl p-4 bg-white'>
            <img src={renovaciones} alt="img not found" className='h-44 w-full'/>
            <div className='flex flex-col items-center justify-center gap-3 p-4'>
              <h1 className='font-bold'>Renovaciones</h1>
              <p className='text-xs'>Si tu tramite inicial fue con nosotras, toca aquí para realizar tu renovación.</p>
              
             
              <button className='w-full p-2 px-4 rounded-xl bg-background_home text-white '
                onClick={() => {
                  if (token) {
                    window.location.href='/renovaciones';
                  } else {
                    Swal.fire({
                      title: 'No esta Logeado',
                      text: 'Debe iniciar sesion para poder ver sus formularios.',
                      icon: 'warning',
                      confirmButtonColor: '#3085d6',
                      confirmButtonText: 'Aceptar'
                    });
                  }
                }}
                >Completar</button>
            
            </div>
        </div>  

          
      
    </div>
  )
}

export default FormsOptions